import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ReasonService } from '../../../services/reason.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';


@Component({
  selector: 'app-resson-dialog',
  template: require('./reason-dialog.component.html'),
  styles: [require('./reason-dialog.component.css')]
})
export class ReasonDialogComponent implements OnInit {

    applicantForm: FormGroup = new FormGroup({});
    isLoading: boolean = false;
    currentReason: any = {};
    isDelete: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogref: MatDialogRef<ReasonDialogComponent>,
        private memberAccessReasonService: ReasonService,
        private fb: FormBuilder
    ) {
        console.log(data);
        this.currentReason = _.cloneDeep(data.reason);
        this.isDelete = data.isDelete;
        console.log(this.isDelete)
    }

    ngOnInit() {
        this.applicantForm = this.fb.group({
            name: ['', Validators.required],
            description: [''],
            orderIndex: ['', [Validators.required, Validators.pattern("^[0-9]*$")]]
        })
    }

    close() {
        this.dialogref.close();
    }

    save() {
        if (this.applicantForm.invalid) {
            Object.keys(this.applicantForm.controls).forEach(i => {
                this.applicantForm.controls[i].markAsTouched();
            })

            return;
        }
        this.currentReason.id ? this.updateMemberAccessReason(this.currentReason) : this.createMemberAccessReason(this.currentReason);
        console.log(this.applicantForm.controls)
    }

    createMemberAccessReason(memberAccessReason) {
        this.memberAccessReasonService.createMemberAccessReason(memberAccessReason).subscribe(r => {
            console.log(r)
            this.dialogref.close(r)
        })
    }

    updateMemberAccessReason(memberAccessReason) {
        this.memberAccessReasonService.updateMemberAccessReason(memberAccessReason).subscribe(r => {
            console.log(r)
            this.dialogref.close(r)
        })
    }


    onConfirm() {
        this.memberAccessReasonService.deleteMemberAccessReason(this.currentReason.id).subscribe(r => {
            if (r) {
                this.dialogref.close(r);
            }
        })
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/reason/reason-dialog/reason-dialog.component.ts